import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { lazy, Suspense } from 'react'

const ThresholdList = lazy(() => import('./components/List'))
const ThresholdDetail = lazy(() => import('./components/Detail'))
const ThresholdCreate = lazy(() => import('./components/Create'))
const ThresholdEdit = lazy(() => import('./components/Edit'))

const LoadingFallback = () => (
    <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
)

const withSuspense = (Component: React.LazyExoticComponent<React.FC>) => (
    <Suspense fallback={<LoadingFallback />}>
        <Component />
    </Suspense>
)

const ThresholdModule: RouteObject = {
    path: 'technical/threshold',
    children: [
        { path: '', element: withSuspense(ThresholdList) },
        { path: 'new', element: withSuspense(ThresholdCreate) },
        { path: ':id', element: withSuspense(ThresholdDetail) },
        { path: ':id/edit', element: withSuspense(ThresholdEdit) },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ThresholdModule
